import Vue from "vue";
import "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import store from "./store/store";
import "./registerServiceWorker";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faGithub, faFontAwesome } from "@fortawesome/free-brands-svg-icons";
import { faCrown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
//import workerMatcher from 'worker-loader!./workers/webworker_matcher.js'
//window.workerMatcher = workerMatcher;
library.add(faCrown);
library.add(faGithub);
library.add(faFontAwesome);
Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false;
if (process.env.NODE_ENV === "production") Vue.config.devtools = false;

Vue.prototype.$cvready = {};
Vue.prototype.$cvready.cbs = [];
Vue.prototype.$cvready.addCb = function(fn) {
  Vue.prototype.$cvready.cbs.push(fn);
};


new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
